import angular from 'angular';
import { saveAs } from 'file-saver/FileSaver';

let VersionListController = function (Version, $mdDialog, $filter, $scope, $state, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    edit
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';
    $ctrl.notification = {
      version: null,
      platform: '',
      isForced: false
    }

    $ctrl.versionList = [];

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at'
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }


  function edit(resource) {
    $ctrl.notification = {
      version: resource.version,
      platform: resource.platform,
      isForced: resource.isForced
    }
    $mdDialog.show({
      controller: DialogController,
      template:
        '<md-dialog aria-label="Version dialog" style="max-width: 600px; padding: 24px;">' +
        '  <md-dialog-content>' +
        '     <h4><strong>EDITAR VERSÃO</strong></h4>'+
        '     <div> Preencha os dados sobre a versão conforme os campos abaixo.' + 
        '       Essas informações serão utilizadas para notificar os usuários da nova versão do aplicativo, sempre que estiverem em uma versão inferior a configurada.' +
        '     </div>' +
        '     <div class="version-form">'+
        '       <md-input-container class="md-block" flex>' +
        '       <label>Versão disponível</label>' +
        '       <input ng-model="notification.version" name="title">' +
        '      </md-input-container>' +
        '       <md-input-container class="md-block" flex>' +
        '         <label>Plataforma</label>' +
        '         <md-select ng-model="notification.platform" disabled>' +
        '          <md-option ng-value="\'ANDROID\'">Android</md-option>' +
        '          <md-option ng-value="\'IOS\'">iOS</md-option>' +
        '         </md-select>' +
        '       </md-input-container>'+
        '       <md-input-container class="md-block">' +
        '       <md-checkbox aria-label="Atualização obrigatória" ng-checked="notification.isForced" ng-model="notification.isForced" >Atualização obrigatória</md-checkbox>' +
        '       </md-input-container>'+
        '     </div>'+
        '     <div>'+
        '     Caso deseje que os usuários não sejam notificados sobre a nova versão disponível, preencha o campo "Versão disponível" com o número 0'+
        '     </div>'+
        '</md-dialog-content>' +
        '<md-dialog-actions>' +
        '  <md-button ng-click="cancel()">Cancelar</md-button>' +
        '  <md-button ng-click="save(notification)" class="md-accent">Salvar</md-button>' +
        '  </md-dialog-actions>' +
        '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (resource) {
        saveData(resource)
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";
    $scope.loadingText = 'Carregando';
    $scope.notification = {
      version: $ctrl.notification.version,
      platform: $ctrl.notification.platform,
      isForced: $ctrl.notification.isForced
    };

    $scope.hide = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.save = function (resource) {
      $mdDialog.hide(resource);
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Version
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.email === null || item.email === undefined) {
  			item.email = $filter('translate')('common-not-informed');
  		}
  	});
  }

  function saveData(resource) {
    $ctrl.promise = Version
      .save(resource)
      .then(response => {
        loadData()
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: '',
          isForced: false
        }
      })
  }
}

VersionListController.$inject = ['Version', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];

export default VersionListController;



// WEBPACK FOOTER //
// ./client/app/components/version/version-list.controller.js